import { combineReducers } from 'redux';
import documents from './document/actions/documents-reducer';
import document from './document/actions/reducer';
import file from './entry-form/actions/reducer';
import finalTerms from './final-terms/actions/reducer';
import finalTerm from './final-terms/final-term/actions/reducer';
import referential from './referential/actions/reducer';
import user from './user/actions/user-reducer';
import validationRules from './validation/actions/reducer';
import wafError from './shared/component/WafErrorModal/action/waf-error-reducer';

export default combineReducers({
  referential,
  user,
  file,
  document: combineReducers({
    document,
    documents,
  }),
  finalTerm: combineReducers({
    finalTerm,
    finalTerms,
  }),
  validationRules,
  wafError,
});
